import type { SelectableMetric } from "@/components/entity-column-selector";
import { CATEGORY_STYLES } from "@/components/metrics/styles";
import type { MetricDefinition } from "@/hooks/api/use-field-definitions";
import {
  DEFAULT_METRIC_ORDER,
  METRIC_CONFIG,
} from "@/pages/salespeople/salesperson-explorer/salesperson-metrics-config";
import { mapMetricTypeToFormulaType } from "./metric-types";

/**
 * Extract salesperson metrics in different formats for various use cases.
 * This function provides both UI-ready metrics and formula-ready metrics.
 */
export function extractSalespersonMetrics(): {
  /** Metrics formatted for UI components like EntityColumnSelector */
  selectableMetrics: SelectableMetric[];
  /** Metrics formatted for formula system with MetricDefinition interface */
  formulaMetrics: MetricDefinition[];
} {
  const selectableMetrics: SelectableMetric[] = DEFAULT_METRIC_ORDER.map(
    (metricKey) => {
      const metricConfig = METRIC_CONFIG[metricKey];
      const categoryStyle = CATEGORY_STYLES[metricConfig.category];

      return {
        id: metricKey,
        title: metricConfig.title,
        tooltip: metricConfig.tooltip,
        category: metricConfig.category,
        categoryStyle: categoryStyle.color,
        categoryIcon: categoryStyle.icon,
      };
    },
  );

  const formulaMetrics: MetricDefinition[] = DEFAULT_METRIC_ORDER.map(
    (metricKey) => {
      const metricConfig = METRIC_CONFIG[metricKey];

      // Map salesperson metric format to formula-compatible data type
      const formulaDataType = mapMetricTypeToFormulaType(metricConfig.format);

      return {
        key: metricKey,
        displayName: metricConfig.title,
        dataType: formulaDataType,
        description: metricConfig.tooltip,
      };
    },
  );

  return {
    selectableMetrics,
    formulaMetrics,
  };
}
